module.exports = __webpack_public_path__ + "correlations.4796ef7aa970b4af49e403e574a9a477.png";